import React from "react";
import "./HRQuoteBanner.css";

const HRQuoteBanner = () => {
  return (
    <section className="hrq-banner">
      <div className="hrq-overlay"></div>

      <div className="hrq-content">
        <p className="hrq-subtitle">GET SOLUTIONS FAST!</p>

        <h2 className="hrq-title">
          Need First-Class <span>HR Consultants?</span>
        </h2>

        <button className="hrq-btn">GET A QUOTE NOW</button>
      </div>
    </section>
  );
};

export default HRQuoteBanner;
